import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { useEffect, useState } from "react";
import { useClientConfigProvider } from "./config/client-config-provider";
import AppRoutes from "./constants/routes";
import { useRouter } from "next/navigation";
import SpinnerLoader from "./component/spinner-loader";
import SpinnerLoaderNew from "./component/spinner-loader-new";
import { Spinner } from "reactstrap";
export default function withAuthRedirect(Component: any) {
  return function WrappedComponent(props: any) {
    const router = useRouter();
    const { config } = useClientConfigProvider();
    const {
      state: { user, memberships },
    } = useAppContext();

    // State to track if redirect decision has been resolved
    const [isRedirectResolved, setIsRedirectResolved] = useState(false);

    const { isFetched: isMembershipFetched, data: membershipsData } =
      memberships ?? {};
    const { isFetched: isUserFetched, data: userData } = user ?? {};

    const auth = Boolean(
      UniversalStorageUtils.getItem(
        config?.nativeDataSavingType,
        UniversalStorageConstants.AUTH_TOKEN
      )
    );

    useEffect(() => {
      // If user is not authenticated, allow component to render normally
      if (!auth) {
        setIsRedirectResolved(true);
        return;
      }

      if (!isUserFetched || !isMembershipFetched) return; // wait for both

      if (
        config?.userRegistration?.preLoginUserRegistrationForm &&
        !userData?.firstName
      ) {
        // router.push(AppRoutes.register);
        // No redirect needed, mark as resolved
        setIsRedirectResolved(true);
      } else if (
        config?.userRegistration?.requiresMembershipLinkBeforeDashboard &&
        !((membershipsData ?? [])?.length > 0)
      ) {
        console.log(
          "USERREGISTRATION",
          ` config?.userRegistration?.requiresMembershipLinkBeforeDashboard &&
        !((membershipsData ?? [])?.length > 0)`
        );
        router.push(
          config?.userRegistration?.afterRegistrationRedirectRoute ??
            AppRoutes.loginLinkMembership
        );
      } else {
        console.log("USERREGISTRATION", `else`);
        router.push(AppRoutes.dashboard);
      }
    }, [
      auth,
      config,
      isUserFetched,
      isMembershipFetched,
      userData?.firstName,
      membershipsData?.length,
      router,
      membershipsData,
    ]);

    // Show loader while determining redirect path
    // Only show component if:
    // 1. User is not authenticated (no redirect needed), OR
    // 2. User is authenticated and redirect decision has been resolved
    if (
      auth &&
      (!isUserFetched || !isMembershipFetched || !isRedirectResolved)
    ) {
      return <Spinner />;
    }

    return <Component {...props} />;
  };
}
